<template>
  <div class="invoice-list-container">
    <b-table
      v-if="invoices.length > 0"
      :fields="fields"
      :items="invoices"
      class="drip-v2-table table-borderless"
      tbody-tr-class="drip-tr-class"
      thead-class="drip-table-head"
    >
      <template v-slot:cell(selected)="data">
        <input type="checkbox" v-model="invoices[data.index].selected" />
      </template>
      <template v-slot:cell(value)="data">
        {{ data.value | currency(data.item.currsym) }}
      </template>
      <template v-slot:cell(advice_collection_pending)="data">
        {{ data.value | currency(data.item.currsym) }}
      </template>
      <template v-slot:cell(repayment)="data">
        {{ data.value | moment('MMMM D, YYYY') }}
      </template>
      <template v-slot:cell(invoice_date)="data">
        {{ data.value | moment('MMMM D, YYYY') }}
      </template>
      <template v-slot:cell(documents_public)="data">
        <b-dropdown right text="Documents" variant="link" class="dropdown-link">
          <b-dropdown-item
            v-for="document in data.value"
            :key="document.id"
            @click="showDocument(document)"
          >
            {{ document.tags_value }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <b-modal
      ref="documentModal"
      size="lg"
      hide-footer
      @hide="documentUrl = null"
      class="document-modal"
    >
      <iframe ref="documentIframe" class="document-iframe" :src="documentUrl" />
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      documentUrl: null,
      fields: this.$t('importers.index.invoicesListTable')
    }
  },
  props: ['invoices'],
  methods: {
    showDocument(document) {
      this.$refs.documentModal.show()
      this.documentUrl = `${process.env.VUE_APP_DRIP_WEB_HOST}/documents/${document.id}/auth/${document.auth_token}`
    }
  }
}
</script>
<style lang="scss">
@import '../../../assets/scss/variables';

.dropdown-link {
  .dropdown-toggle {
    padding: 0;
  }
}

.document-iframe {
  border: 0;
  width: 100%;
  min-height: 600px;
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
  .document-modal {
    .modal-lg {
      max-width: 1000px;
    }
  }
}

.po-col {
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
</style>
